export default "__VITE_ASSET__BmgVFP6Q__"